import { WorkspaceDetails } from "@common/types/workspace";
import { EntityIconList } from "@components/general/EntityIconList/EntityIconList";
import { GridTableRow } from "@components/general/Tables/GridTable/GridTable";
import { useInteraction } from "@hooks/useInteraction";
import { useWorkspaceContext } from "@state/workspaceContext";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Workspaces.module.scss";
import { WorkspaceAssignmentsList } from "./WorkspaceAssignmentsList";

interface WorkspaceRowProps {
    workspace: WorkspaceDetails;
}

export const WorkspaceRow: FC<WorkspaceRowProps> = ({ workspace }) => {
    const navigate = useNavigate();
    const { changeActiveWorkspace } = useWorkspaceContext();
    const switchToClientInteraction = useInteraction(() => {
        changeActiveWorkspace(workspace.workspace);
        navigate("/");
    });

    return (
        <GridTableRow
            key={workspace.workspace.id}
            className={styles.workspaceRow}
            {...switchToClientInteraction}
        >
            <div>
                <strong>{workspace.workspace.name}</strong>
            </div>
            <div>
                {workspace.entities.length > 0 ? (
                    <EntityIconList
                        entities={workspace.entities}
                        maxEntitiesToDisplay={Number.MAX_VALUE}
                        showLabel={false}
                    />
                ) : null}
            </div>
            <div>
                <WorkspaceAssignmentsList assignments={workspace.assignments} />
            </div>
        </GridTableRow>
    );
};
